export function abbNumber(number: number | any, decimals: number) {
  if (!number) {
    return '0'
  }
  if (number < 1000) {
    return number.toString()
  }

  const ranges = [
    { divider: 1e12, suffix: 'T' },
    { divider: 1e9, suffix: 'B' },
    { divider: 1e6, suffix: 'M' },
    { divider: 1e3, suffix: 'K' },
  ];

  for (const range of ranges) {
    if (number >= range.divider) {
      return (number / range.divider).toFixed(decimals) + range.suffix
    }
  }
}